// utils/apiError.js
// L'API ne traduit rien : elle renvoie
//   { message, details, code, errors: [{ field, type, context }] }
// et c'est le frontend qui affiche le texte dans la langue courante (i18n fr/ar) :
//   - `errors`  -> erreurs de validation Joi, via validation.types.* et validation.fields.*
//   - `code`    -> erreur métier, via errors.<CODE>
//   - sinon     -> `message` renvoyé par l'API, puis `fallback`.
import i18n from "../i18n";

const lastName = (field = "") => {
  const parts = String(field).split(".").filter((p) => p && Number.isNaN(Number(p)));
  return parts[parts.length - 1] || "";
};

function translateValidationError(e) {
  const name = lastName(e.field);
  const fieldKey = `validation.fields.${name}`;
  const field = name && i18n.exists(fieldKey) ? i18n.t(fieldKey) : name;
  const typeKey = `validation.types.${String(e.type || "").replace(/\./g, "_")}`;
  const ctx = e.context || {};
  return i18n.exists(typeKey)
    ? i18n.t(typeKey, { field, limit: ctx.limit ?? ctx.min ?? ctx.max })
    : i18n.t("validation.types.invalid", { field });
}

export function getApiErrorMessage(err, fallback = "") {
  const data = err?.response?.data;
  if (Array.isArray(data?.errors) && data.errors.length) {
    return data.errors.map(translateValidationError).join("\n");
  }
  if (data?.code && i18n.exists(`errors.${data.code}`)) return i18n.t(`errors.${data.code}`);
  return data?.message || fallback;
}
